import decode from 'jwt-decode';
import axios from 'axios';
const TEMP_TOKEN_NAME = 'mp_temp_token_web';
const TOKEN_NAME = 'mp_token_web';
const GUEST_TOKEN_NAME = 'mp_guest_token';
const LOGIN_ENDPOINT = 'login_controller/validar/';
//const LOGIN_VALIDA_ENDPOINT = 'login_controller/validartoken/';



axios.interceptors.request.use(function (config) {
    config.metadata = { startTime: new Date() }; return config;
}, function (error) { return Promise.reject(error); });


axios.interceptors.response.use(function (response) {
    response.config.metadata.endTime = new Date()
    response.duration = response.config.metadata.endTime - response.config.metadata.startTime
    return response;
}, function (error) {
    return Promise.reject(error);
});

export default class AuthService {
    // Initializing important variables
    constructor(domain) {
        this.domain = domain || process.env.REACT_APP_API_URI // API server domain
        this.login = this.login.bind(this)
        this.getProfile = this.getProfile.bind(this)
    }

    async login(user, password) {
        // Get a token from api server using the fetch api
        return axios.post(`${this.domain}` + LOGIN_ENDPOINT, { user: user, password: password })
            .then((responseJson) => {
                if (responseJson.data['api-key'] !== undefined && responseJson.data['api-key'].length > 0) {
                    this.setToken(responseJson.data['api-key']);
                }
                return responseJson.data;
            })
            .catch((error) => {
                console.error('post helper error ' + error);
            });
    }

    async loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken() // GEtting token from localstorage
        return !!token && !this.isTokenExpired(token) // handwaiving here
    }

    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return false;
        }
    }

    getLink(url, params = false) {
        if (params) {
            params += '&X-API-KEY=' + this.getToken();
        } else {
            params = '?X-API-KEY=' + this.getToken();
        }
        url = this.domain + url + params;
        return url;
    }

    get(url, params = false) {
        axios.defaults.headers.common = { 'Authorization': `Bearer ${this.getToken()}` }
        if (params) {
            params['X-API-KEY'] = this.getToken();
        } else {
            params = { 'X-API-KEY': this.getToken() };
        }
        url = this.domain + url;
        var response = axios.get(url, { params: params })
            .then((responseJson) => {
                responseJson.data.duration = responseJson.duration;

                return responseJson.data;
            })
            .catch((error) => {
                console.error('get helper error ' + error);
            });
        return response;
    }

    createAuthLink(url, params = false) {
        return this.domain + url + '?X-API-KEY=' + this.getToken();
    }



    async getPublic(url, params = false) {
        var domain = this.domain;
        var url_token = domain + url;
        var response = axios.get(url_token, { params: params })
            .then((responseJson) => {
                responseJson.data.duration = responseJson.duration;
                return responseJson.data;
            })
            .catch((error) => {
                //console.log('url', url_token, 'params', params);
                console.error('get helper error ' + error, url_token, params);
            });
        return response;
    }

    post(url, data) {
        axios.defaults.headers.common = { 'Authorization': `Bearer ${this.getToken()}` }
        var url_token = this.domain + url + 'X-API-KEY/' + this.getToken();
        console.log('urltoken ', url_token, 'data', data);
        var response = axios.post(url_token, data)
            .then((responseJson) => {
                responseJson.data.duration = responseJson.duration;
                return responseJson.data;
            })
            .catch((error) => {
                console.error('post helper error ' + error);
            });
        return response;
    }

    setToken(idToken) {
        // Saves user token to localStorage
        localStorage.setItem(TOKEN_NAME, idToken)
    }

    getToken() {
        // Retrieves the user token from localStorage
        return localStorage.getItem(TOKEN_NAME)
    }

    setGuestToken(idToken) {
        // Saves user token to localStorage
        const tempAdminToken = this.getToken();

        localStorage.setItem(TEMP_TOKEN_NAME, tempAdminToken);
        localStorage.setItem(GUEST_TOKEN_NAME, idToken);
    }

    getGuestToken() {
        // Retrieves the user token from localStorage
        return localStorage.getItem(GUEST_TOKEN_NAME)
    }

    logout(removeAltTokens = true) {
        // Clear user token and profile data from localStorage
        if (navigator.serviceWorker) {
            navigator.serviceWorker.removeEventListener('message', (event) => { console.log('cerrando listener de service worker') });
            navigator.serviceWorker.getRegistration().then(registration => registration ? registration.unregister() : '');
        }

        if (removeAltTokens) {
            localStorage.removeItem(GUEST_TOKEN_NAME);
            localStorage.removeItem(TEMP_TOKEN_NAME);
        }

        localStorage.removeItem(TOKEN_NAME);
        localStorage.removeItem('routes');
    }

    getProfile() {
        // Using jwt-decode npm package to decode the token
        return decode(this.getToken());
    }

    isProfile(name) {
        return this.getToken() && this.getProfile().rol === name ? true : false;
    }


    filterRoutes(routes) {
        let finalRoutes = [];
        routes.publicRoutes.map(cada_ruta => finalRoutes.push(cada_ruta));

        if (this.getToken()) {
            var profile = this.getProfile();
            if (profile.rol === 'proveedor') {
                routes.routesPetshops.map(cada_ruta => finalRoutes.push(cada_ruta));
            }
            else if (profile.rol === 'account manager') {
                routes.routesAccountManager.map(cada_ruta => finalRoutes.push(cada_ruta));
            }
            else if (profile.rol === 'atencion cliente') {
                routes.routesCustomerService.map(cada_ruta => finalRoutes.push(cada_ruta));
            }
            else if (profile.rol === 'marketing') {
                routes.routesMarketingManager.map(cada_ruta => finalRoutes.push(cada_ruta));
            }
            else if (profile.rol === 'admin') {
                routes.routesCustomerService.map(cada_ruta => finalRoutes.push(cada_ruta));
                routes.routesAccountManager.map(cada_ruta => finalRoutes.push(cada_ruta));
                routes.routesAdmin.map(cada_ruta => finalRoutes.push(cada_ruta));
                routes.routesTMS.map(cada_ruta => finalRoutes.push(cada_ruta));
            }

        }
        localStorage.setItem('routes', JSON.stringify(finalRoutes));
        return finalRoutes;
    }

    isWareHouse() {
        return localStorage.getItem('isWareHouse') == 'true' ? true : false
    }
}

